package io.horion.cv.components.widgets

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.icons.fa.FaCheck
import com.varabyte.kobweb.silk.components.icons.fa.FaTrash
import com.varabyte.kobweb.silk.components.icons.fa.FaTrashCan
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import io.horion.cv.styles.CompleteButtonStyle
import io.horion.cv.styles.CompleteButtonIconStyle
import io.horion.cv.styles.CompleteButtonTextStyle
import io.horion.cv.styles.DeleteButtonStyle
import io.horion.cv.styles.DeleteButtonIconStyle
import io.horion.cv.utils.Colors
import io.horion.cv.utils.Constants.INTER
import org.jetbrains.compose.web.css.px

@Composable
fun FormActionButtons(
    onDelete: () -> Unit,
    onComplete: () -> Unit,
    modifier: Modifier = Modifier,
) {
    Row(
        modifier = modifier.fillMaxWidth(),
        horizontalArrangement = Arrangement.End,
        verticalAlignment = Alignment.CenterVertically
    ) {

        Box(
            modifier = DeleteButtonStyle.toModifier()
                .borderRadius(7.px)
                .backgroundColor(Colors.White)
                .cursor(Cursor.Pointer)
                .onClick { onDelete() },
            contentAlignment = Alignment.Center
        ) {

            FaTrashCan(
                modifier = DeleteButtonIconStyle.toModifier()
                    .color(Color.rgb(0xb5, 0xb5, 0xb5))
            )
        }

        Box(modifier = Modifier.width(10.px))

        // Bouton Terminer
        Box(
            modifier = CompleteButtonStyle.toModifier()
                .borderRadius(7.px)
                .cursor(Cursor.Pointer)
                .onClick { onComplete() },
            contentAlignment = Alignment.Center
        ) {
            Row(
                horizontalArrangement = Arrangement.spacedBy(5.px),
                verticalAlignment = Alignment.CenterVertically
            ) {

                FaCheck(
                    modifier = CompleteButtonIconStyle.toModifier()
                        .color(Colors.White)
                )
                SpanText(
                    text = "Terminé",
                    modifier = CompleteButtonTextStyle.toModifier()
                        .color(Colors.White)
                        .fontFamily(INTER)
                        .fontWeight(FontWeight.Medium)
                )
            }
        }
    }
}